// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_userProfileWrapper__QeKwe {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 100px);
  padding: 40px 20px;
}

.styles_cardBox__swJ9z {
  border-radius: 40px !important;
  background-color: var(--color-white) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
  max-width: 900px !important;
  width: 100% !important;
  height: 600px !important;
  overflow: hidden !important;
}

.styles_scrollBox__rG-79 {
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
  height: 100% !important;
  overflow: hidden !important;
}

.styles_userProfileCard__CD90n {
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  height: 100% !important;
  width: 100% !important;
  display: flex !important;
  overflow: hidden !important;
}

.styles_userProfileNavbar__fEBXl {
  background-color: #f5f5f5 !important;
  border-right: 1px solid #e0e0e0 !important;
  min-width: 200px !important;
  padding: 20px !important;
}

.styles_userProfileNavButton__1HZ3E {
  color: var(--color-text-secondary) !important;
  font: var(--typography-body-m-regular) !important;
  padding: 12px 20px !important;
  border-radius: 8px !important;
  margin: 4px 8px !important;
  transition: all 0.2s !important;
}
.styles_userProfileNavButton__1HZ3E:hover {
  background-color: var(--color-background-hover) !important;
  color: var(--color-text-primary) !important;
}

.styles_userProfileNavButtonActive__vBCTH {
  background-color: var(--color-accent-blue) !important;
  color: var(--color-white) !important;
}

.styles_userProfileContent__UlvMR {
  padding: 32px !important;
  overflow-y: auto !important;
  height: 100% !important;
  background-color: var(--color-white) !important;
}

.styles_userProfileButton__--hcv {
  background-color: var(--color-accent-blue) !important;
  color: var(--color-white) !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font: var(--typography-body-m-medium) !important;
  transition: background-color 0.2s !important;
}
.styles_userProfileButton__--hcv:hover {
  background-color: var(--color-accent-blue-dark) !important;
}

.styles_pageHeader__lSBVp {
  width: 100%;
  max-width: 900px;
  margin-bottom: 24px;
  text-align: center;
}
.styles_pageHeader__lSBVp h1 {
  font-size: 32px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}

.styles_hideElement__AnDwy {
  display: none !important;
}

.styles_signOutPage__LEYeR {
  padding: 20px 0;
}

.styles_signOutTitle__0WHE0 {
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 12px 0;
}

.styles_signOutText__Gsewz {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.styles_signOutButton__oRIo5 {
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.styles_signOutButton__oRIo5:hover {
  background-color: #dc2626;
}`, "",{"version":3,"sources":["webpack://./src/screens/user-profile/styles.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,+CAAA;EACA,oDAAA;EACA,2BAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,kCAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,oCAAA;EACA,0CAAA;EACA,2BAAA;EACA,wBAAA;AAAF;;AAGA;EACE,6CAAA;EACA,iDAAA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,+BAAA;AAAF;AAEE;EACE,0DAAA;EACA,2CAAA;AAAJ;;AAIA;EACE,qDAAA;EACA,oCAAA;AADF;;AAIA;EACE,wBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+CAAA;AADF;;AAIA;EACE,qDAAA;EACA,oCAAA;EACA,6BAAA;EACA,6BAAA;EACA,gDAAA;EACA,4CAAA;AADF;AAGE;EACE,0DAAA;AADJ;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAFF;AAIE;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;AAFJ;;AAMA;EACE,wBAAA;AAHF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;AAJF;;AAOA;EACE,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAJF;AAME;EACE,yBAAA;AAJJ","sourcesContent":["@import \"mixins\";\n.userProfileWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: calc(100vh - 100px);\n  padding: 40px 20px;\n}\n\n.cardBox {\n  border-radius: 40px !important;\n  background-color: var(--color-white) !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;\n  max-width: 900px !important;\n  width: 100% !important;\n  height: 600px !important;\n  overflow: hidden !important;\n}\n\n.scrollBox {\n  box-shadow: none !important;\n  border: none !important;\n  border-radius: 0 !important;\n  height: 100% !important;\n  overflow: hidden !important;\n}\n\n.userProfileCard {\n  background: transparent !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  height: 100% !important;\n  width: 100% !important;\n  display: flex !important;\n  overflow: hidden !important;\n}\n\n.userProfileNavbar {\n  background-color: #f5f5f5 !important;\n  border-right: 1px solid #e0e0e0 !important;\n  min-width: 200px !important;\n  padding: 20px !important;\n}\n\n.userProfileNavButton {\n  color: var(--color-text-secondary) !important;\n  font: var(--typography-body-m-regular) !important;\n  padding: 12px 20px !important;\n  border-radius: 8px !important;\n  margin: 4px 8px !important;\n  transition: all 0.2s !important;\n\n  &:hover {\n    background-color: var(--color-background-hover) !important;\n    color: var(--color-text-primary) !important;\n  }\n}\n\n.userProfileNavButtonActive {\n  background-color: var(--color-accent-blue) !important;\n  color: var(--color-white) !important;\n}\n\n.userProfileContent {\n  padding: 32px !important;\n  overflow-y: auto !important;\n  height: 100% !important;\n  background-color: var(--color-white) !important;\n}\n\n.userProfileButton {\n  background-color: var(--color-accent-blue) !important;\n  color: var(--color-white) !important;\n  border-radius: 8px !important;\n  padding: 12px 24px !important;\n  font: var(--typography-body-m-medium) !important;\n  transition: background-color 0.2s !important;\n\n  &:hover {\n    background-color: var(--color-accent-blue-dark) !important;\n  }\n}\n\n.pageHeader {\n  width: 100%;\n  max-width: 900px;\n  margin-bottom: 24px;\n  text-align: center;\n\n  h1 {\n    font-size: 32px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n    margin: 0;\n  }\n}\n\n.hideElement {\n  display: none !important;\n}\n\n// Sign out page styles\n.signOutPage {\n  padding: 20px 0;\n}\n\n.signOutTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0 0 12px 0;\n}\n\n.signOutText {\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n.signOutButton {\n  background-color: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: #dc2626;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userProfileWrapper": `styles_userProfileWrapper__QeKwe`,
	"cardBox": `styles_cardBox__swJ9z`,
	"scrollBox": `styles_scrollBox__rG-79`,
	"userProfileCard": `styles_userProfileCard__CD90n`,
	"userProfileNavbar": `styles_userProfileNavbar__fEBXl`,
	"userProfileNavButton": `styles_userProfileNavButton__1HZ3E`,
	"userProfileNavButtonActive": `styles_userProfileNavButtonActive__vBCTH`,
	"userProfileContent": `styles_userProfileContent__UlvMR`,
	"userProfileButton": `styles_userProfileButton__--hcv`,
	"pageHeader": `styles_pageHeader__lSBVp`,
	"hideElement": `styles_hideElement__AnDwy`,
	"signOutPage": `styles_signOutPage__LEYeR`,
	"signOutTitle": `styles_signOutTitle__0WHE0`,
	"signOutText": `styles_signOutText__Gsewz`,
	"signOutButton": `styles_signOutButton__oRIo5`
};
export default ___CSS_LOADER_EXPORT___;
